import React, {useState} from "react"

import {QueryStatus} from "src/types"

import {useDetalleCLFB} from "../hooks/useDetalleCLFB";
import {OperacionCLFBDetalleFields} from "../types/fields";
import {CardCollapse} from "../../../components";
import {CLFBDetalle, schemaCLFBDetalle} from "../types/types";
import {Button, Dialog, DialogActions, DialogContent, DialogTitle, Tooltip} from "@mui/material";
import SeccionCLFBDatosAdicionalesDialog from "./SeccionCLFBDatosAdicionalesDialog";
import {useForm} from "react-hook-form";
import {zodResolver} from "@hookform/resolvers/zod";
import {HttpCLFB} from "../api/HttpCLFB";
import toast from "react-hot-toast";
import {TABLE_VIEW} from "../../../components/SharedIcons";
import {useDetalleHistoriaCLFB} from "../hooks/useDetalleHistoriaCLFB";
import SeccionClfbDetalleHistoriaTabla from "./SeccionCLFBDetalleHistoriaTabla";
import CLFBDetalleTabla from "./CLFBDetalleTabla";

type SeccionCLFBDetalle = {
    idOperacion: number
    codPais: number
    permiteEditar: boolean
    permiteEliminar: boolean
    adicionales?: React.ReactElement
}

const SeccionCLFBDetalle = ({
                                idOperacion,
                                codPais,
                                permiteEditar,
                                permiteEliminar,
                                adicionales
                            }: SeccionCLFBDetalle) => {

    const [openDialog, setOpenDialog] = useState<boolean>(false);
    const {status, detalles, refetch} = useDetalleCLFB(idOperacion)

    const [openDialogHistoria, setOpenDialogHistoria] = useState<boolean>(false);
    const {
        status: statusHistoria,
        detalles: detallesHistoria,
        refetch: refetchHistoria
    } = useDetalleHistoriaCLFB(idOperacion)

    const {control, handleSubmit, reset, getValues} = useForm<CLFBDetalle>({
        resolver: zodResolver(schemaCLFBDetalle),
    })

    const alGuardarDetalle = (data: CLFBDetalle) => {
        const dataToSave = {
            ...data,
            [OperacionCLFBDetalleFields.DescOperacionActivoTipo]: data[OperacionCLFBDetalleFields.CodOperacionActivoTipo] ? null : data[OperacionCLFBDetalleFields.DescOperacionActivoTipo],
        }
        const promise = HttpCLFB.putDetalle(data[OperacionCLFBDetalleFields.IdOperacion], data.id, dataToSave)

        toast.promise(promise, {
            loading: 'Guardando.',
            success: 'Guardado correctamente.',
            error: e => `${e}`
        }).finally(() => {
            reset()
            refetch()
            setOpenDialog(false)
        })
    }


    return (
        <CardCollapse
            title={"Detalles"}
            colapsable
            tableContent

            actions={
                <Tooltip title={`${detallesHistoria.length > 0 ? 'Ver Historia' : 'No se encontró historia'}`}>
                    <div>
                        <Button variant="contained" color="primary" endIcon={TABLE_VIEW}
                                onClick={() => setOpenDialogHistoria(true)}
                                disabled={detallesHistoria.length == 0}
                        >
                            Historia
                        </Button>
                    </div>

                </Tooltip>

            }
        >

            <CLFBDetalleTabla
                detalles={detalles}
                codPais={codPais}
                permiteEditar={permiteEditar}
                alGuardarDetalle={alGuardarDetalle}
                isLoading={status === QueryStatus.Loading}
                error={status === QueryStatus.Error}
                adicionales={adicionales}
            />

            {
                openDialog &&
                <SeccionCLFBDatosAdicionalesDialog
                    open={openDialog}
                    codPais={codPais} control={control}
                    onClose={() => setOpenDialog(false)}
                    onSubmit={handleSubmit(alGuardarDetalle)}
                    dialogTitle={'Editar Activo'}
                />
            }

            {
                openDialogHistoria &&
                <Dialog open={openDialogHistoria}
                        maxWidth={'xl'} fullWidth
                        onClose={() => setOpenDialogHistoria(false)}>
                    <DialogTitle>Historia</DialogTitle>
                    <DialogContent>
                        <SeccionClfbDetalleHistoriaTabla detalles={detallesHistoria}/>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => setOpenDialogHistoria(false)} color="primary">
                            Cerrar
                        </Button>
                    </DialogActions>
                </Dialog>
            }
        </CardCollapse>
    )
}

export default SeccionCLFBDetalle
